import { getCalcInputState } from "../../../../../utils/selectors";
import { girderSlice } from "./slice";

export const getGirderState = (state) => getCalcInputState(state)[girderSlice.name]
